import React, { useEffect, useState } from "react";
import { getBotbPrizeStraplineTexts } from "../subscription-service";

type CompetitionPrizeTypes = {
  PrizeStraplineText1: string;
  PrizeStraplineText2: string;
  PrizeStraplineText3: string;
};

const getSpecsData = (straplineTexts: CompetitionPrizeTypes) => [
  {
    img: "/assets/images/subscriptions/top-specs-1.webp",
    title: `${straplineTexts.PrizeStraplineText1}y+`,
    description: (
      <>
        UK’s
        <br className={"lg:hidden"} /> No. 1
      </>
    ),
  },
  {
    img: "/assets/images/subscriptions/top-specs-2.webp",
    title: "4.8 +",
    description: (
      <>
        App Store
        <br className={"lg:hidden"} /> Rating
      </>
    ),
  },
  {
    img: "/assets/images/subscriptions/top-specs-3.webp",
    title: `${straplineTexts.PrizeStraplineText2}`,
    description: (
      <>
        In Prizes
        <br className={"lg:hidden"} /> Given
      </>
    ),
  },
  {
    img: "/assets/images/subscriptions/top-specs-4.webp",
    title: "2.7M",
    description: (
      <>
        #1 Community <br className={"lg:hidden"} /> of Prize Lovers
      </>
    ),
  },
];

const Specs = () => {
  const [straplineTexts, setStraplineTexts] = useState<CompetitionPrizeTypes>({
    PrizeStraplineText1: "",
    PrizeStraplineText2: "",
    PrizeStraplineText3: "",
  });

  useEffect(() => {
    getBotbPrizeStraplineTexts()
      .then(res => res.json())
      .then((res: CompetitionPrizeTypes) => {
        setStraplineTexts(res);
      })
      .catch(err => console.error(err));
  }, []);

  const specs = getSpecsData(straplineTexts);

  return (
    <div
      className={
        "w-full flex justify-center items-center bg-white px-6 py-7 lg:px-[195px] lg:py-9 rounded-lg mb-10 lg:mb-16"
      }>
      <div className={"max-lg:grid max-lg:grid-cols-4 gap-1.5 font-jost lg:flex lg:items-center lg:gap-[43px]"}>
        {specs.map((item, index) => (
          <React.Fragment key={index}>
            <div className={"flex flex-col max-lg:items-start items-center gap-1 lg:flex-row lg:gap-2"}>
              <div className={"shrink-0"}>
                <img src={item.img} alt={item.title} width={48} height={48} className={"size-8 lg:size-12"} />
              </div>
              <div>
                <div className={"text-primary text-sm font-semibold leading-5 lg:text-xl"}>{item.title}</div>
                <div className={"text-secondary text-xs font-medium leading-3 lg:text-[13px] lg:leading-[15px]"}>
                  {item.description}
                </div>
              </div>
            </div>

            {index < specs.length - 1 && <div className={"max-lg:hidden w-[3px] h-10 bg-black/8"} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Specs;
